// import { REHYDRATE } from "redux-persist/es/constants";
import * as types from "./types";

const initialState = {
  localities: [],
  infoModal: null,
  manifestItems: [],
};

export default function storesStore(state = initialState, action) {
  // let incoming;
  switch (action.type) {
    case types.GET_STORE_ORDERS_INIT:
      return {
        ...state,
        isGettingStoreOrders: true,
      };
    case types.GET_STORE_ORDERS_COMPLETE:
      return {
        ...state,
        isGettingStoreOrders: false,
        storeOrders: action.payload,
      };
    case types.GET_STORE_ORDERS_ERROR:
      return {
        ...state,
        isGettingStoreOrders: false,
      };
    case types.SHOW_MANAGER_FORM:
      return {
        ...state,
        showManagerForm: action.payload,
      };
    case types.UPDATE_STORE_MANAGER_INIT:
      return {
        ...state,
        isUpdatingStoreManager: true,
      };
    case types.UPDATE_STORE_MANAGER_COMPLETE:
      return {
        ...state,
        isUpdatingStoreManager: false,
        showManagerForm: false,
      };
    case types.UPDATE_STORE_MANAGER_ERROR:
      return {
        ...state,
        isUpdatingStoreManager: false,
      };
    case types.UPDATE_STORE_INIT:
      return {
        ...state,
        isUpdatingStore: true,
      };
    case types.UPDATE_STORE_COMPLETE:
      return {
        ...state,
        isUpdatingStore: false,
      };
    case types.UPDATE_STORE_ERROR:
      return {
        ...state,
        isUpdatingStore: false,
      };
    case types.SET_CURRENT_STORE_ORDER:
      return {
        ...state,
        currentStoreOrder: action.payload,
      };
    case types.GET_STORE_VARIANTS_INIT:
      return {
        ...state,
        isGettingStoreVariants: true,
      };
    case types.GET_STORE_VARIANTS_COMPLETE:
      return {
        ...state,
        isGettingStoreVariants: false,
        storeVariants: action.payload,
      };
    case types.GET_STORE_VARIANTS_ERROR:
      return {
        ...state,
        isGettingStoreVariants: false,
      };
    case types.GET_STORE_SUBCATEGORY_INIT:
      return {
        ...state,
        isLoadingSubCategory: true,
      };
    case types.GET_STORE_SUBCATEGORY_COMPLETE:
      return {
        ...state,
        isLoadingSubCategory: false,
        subCategory: action.payload,
      };
    case types.GET_STORE_SUBCATEGORY_ERROR:
      return {
        ...state,
        isLoadingSubCategory: false,
      };
    case types.UPDATE_STORE_ORDER_INIT:
      return {
        ...state,
        isUpdatingStoreOrder: true,
      };
    case types.UPDATE_STORE_ORDER_COMPLETE:
      return {
        ...state,
        isUpdatingStoreOrder: false,
        currentStoreOrder: {
          ...state.currentStoreOrder,
          status: action.payload.status,
          ticket: action.payload.ticket
        },
      };
    case types.UPDATE_STORE_ORDER_ERROR:
      return {
        ...state,
        isUpdatingStoreOrder: false,
      };
    case types.REFUND_ORDER_INIT:
      return {
        ...state,
        isUpdatingStoreOrder: true,
      };
    case types.REFUND_ORDER_COMPLETE:
      return {
        ...state,
        isUpdatingStoreOrder: false,
        currentStoreOrder: action.payload,
      };
    case types.REFUND_ORDER_ERROR:
      return {
        ...state,
        isUpdatingStoreOrder: false,
      };
    case types.GET_STORE_MANIFEST_INIT:
      return {
        ...state,
        isLoadingManifest: true,
        manifest: [],
      };
    case types.GET_STORE_MANIFEST_COMPLETE:
      return {
        ...state,
        isLoadingManifest: false,
        manifest: action.payload,
      };
    case types.GET_STORE_MANIFEST_ERROR:
      return {
        ...state,
        isLoadingManifest: false,
        manifest: [],
      };
    case types.UPDATE_STORE_MANIFEST_INIT:
      return {
        ...state,
        manifestItems: {},
      };
    case types.UPDATE_STORE_MANIFEST_COMPLETE:
      return {
        ...state,
        manifestItems: action.payload,
      };
    case types.POST_STORE_MANIFEST_INIT:
      return {
        ...state,
        isLoadingManifestCreate: true,
      };
    case types.POST_STORE_MANIFEST_COMPLETE:
      return {
        ...state,
        isLoadingManifestCreate: false,
      };
    case types.POST_STORE_MANIFEST_ERROR:
      return {
        ...state,
        isLoadingManifestCreate: false,
      };
    case types.GET_STORE_MANIFEST_ORDERS_INIT:
      return {
        ...state,
        isLoadingManifestOrders: true,
        activeBtn: false,
      };
    case types.GET_STORE_MANIFEST_ORDERS_COMPLETE:
      return {
        ...state,
        isLoadingManifestOrders: false,
        activeBtn: action.payload,
        listManifiest: action.listManifiest,
      };
    case types.GET_STORE_MANIFEST_ORDERS_ERROR:
      return {
        ...state,
        isLoadingManifestOrders: false,
        activeBtn: false,
      };
    case types.GET_DETAIL_COMMERCE_COMPLETE:
      return {
        ...state,
        detailStore: action.payload,
      };
      case types.GET_MATRIX_PRODUCTS_INIT:
        return {
          ...state,
          isLoadingMatrixProducts: true,
          matrixProducts: null,
          errorMatrixProducts:null,
        };
      case types.GET_MATRIX_PRODUCTS_COMPLETE:
        return {
          ...state,
          isLoadingMatrixProducts: false,
          // matrixProducts: action.payload,
          matrixProducts: action.payload.data,
          totalPagesProducts: action.payload.totalPages,
          errorMatrixProducts:null,
        };
      case types.GET_MATRIX_PRODUCTS_ERROR:
        return {
          ...state,
          isLoadingMatrixProducts: false,
          matrixProducts: action.payload,
          errorMatrixProducts:"error.GET_MATRIX_PRODUCTS_ERROR",
        };
        case types.GET_PRODUCTS_TO_ADD_INIT:
        return {
          ...state,
          isLoadingProductsToAdd: true,
          productsToAdd: null,
          errorProductsToAdd:null,
        };
      case types.GET_PRODUCTS_TO_ADD_COMPLETE:
        return {
          ...state,
          isLoadingProductsToAdd: false,
          // matrixProducts: action.payload,
          productsToAdd: action.payload,
          totalPagesProductsToAdd: action.payload.totalPages,
          errorProductsToAdd:null,
        };
      case types.GET_PRODUCTS_TO_ADD_ERROR:
        return {
          ...state,
          isLoadingProductsToAdd: false,
          productsToAdd: action.payload,
          errorProductsToAdd:"error.GET_MATRIX_PRODUCTS_ERROR",
        };
        case types.ADD_PRODUCT_ORDER_INIT:
          return {
            ...state,
            loadAddProductOrder: true,
            responseAddProduct: null,
            errorAddProductOrder: null,
          };
        case types.ADD_PRODUCT_ORDER_COMPLETE:
          return {
            ...state,
            loadAddProductOrder: false,
            responseAddProduct: action.payload,
            errorAddProductOrder: null,
          };
        case types.ADD_PRODUCT_ORDER_ERROR:
          return {
            ...state,
            loadAddProductOrder: false,
            responseAddProduct: null,
            errorAddProductOrder: "error.ADD_PRODUCT_ORDER_ERROR",
          };
          case types.GET_STOCKS_BY_VARIANT_INIT:
            return {
              ...state,
              loadStocksByVariant: true,
              stocksByVariant: null,
              errorStocksByVariant: null,
            };
          case types.GET_STOCKS_BY_VARIANT_COMPLETE:
            return {
              ...state,
              loadStocksByVariant: false,
              stocksByVariant: action.payload,
              errorStocksByVariant: null,
            };
          case types.GET_STOCKS_BY_VARIANT_ERROR:
            return {
              ...state,
              loadStocksByVariant: false,
              stocksByVariant: null,
              errorStocksByVariant: "error.GET_STOCKS_BY_VARIANT_ERROR",
            };
            case types.GET_REASONS_FOR_REFUND_INIT:
            return {
              ...state,
              loadReasonsForRefund: true,
              reasonsForRefund: null,
              errorReasonsForRefund: null,
            };
          case types.GET_REASONS_FOR_REFUND_COMPLETE:
            return {
              ...state,
              loadReasonsForRefund: false,
              reasonsForRefund: action.payload,
              errorReasonsForRefund: null,
            };
          case types.GET_REASONS_FOR_REFUND_ERROR:
            return {
              ...state,
              loadReasonsForRefund: false,
              reasonsForRefund: null,
              errorReasonsForRefund: "error.GET_REASONS_FOR_REFUND_ERROR",
            };
            case types.UPDATE_I_VARIANT_2_INIT:
              return {
                ...state,
                iVariant1Gral: action.iVariant1Gral,
                iVariant2Gral: action.iVariant2Gral,
            };
            
    default:
      return state;
  }
}
